import api from './api.js'

// Prediction Service (ML deal win predictions + funnel forecast)
export const predictionService = {
  async getForProspect(prospectId) {
    const response = await api.get(`/predictions/${prospectId}`)
    return response.data.success ? response.data.data : null
  },

  async getBatch(prospectIds) {
    const response = await api.post('/predictions/batch', { prospect_ids: prospectIds })
    return response.data.success ? response.data.data : []
  },

  async getActiveModel() {
    const response = await api.get('/predictions/models/active')
    return response.data.success ? response.data.data : null
  },

  async getPipeline() {
    const response = await api.get('/predictions/pipeline')
    return response.data.success ? response.data.data : null
  },

  async getForecast(weeks = 12) {
    const response = await api.get('/predictions/forecast', { params: { weeks } })
    return response.data.success ? response.data.data : null
  },

  async scoreAll() {
    const response = await api.post('/predictions/score-all', {}, { timeout: 120000 })
    return response.data.success ? response.data.data : null
  },

  async getEmployeePipeline() {
    const response = await api.get('/predictions/pipeline/per-employee')
    return response.data.success ? response.data.data : null
  },

  async trainModel() {
    const response = await api.post('/predictions/train', {}, { timeout: 300000 })
    return response.data
  }
}
